function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
import { attach } from 'meteora';
var toggleHeight = /*#__PURE__*/function () {
  function toggleHeight(el) {
    var _this = this;
    var minHeight = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
    var duration = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 300;
    _classCallCheck(this, toggleHeight);
    this.el = el;
    this.duration = duration;
    this.currentHeight = this.el.clientHeight;
    this.reinit = null;
    this.minHeight = minHeight;

    // Initialise
    this.el.style.msTransition = "height ".concat(this.duration, "ms ease-out");
    this.el.style.webkitTransition = "height ".concat(this.duration, "ms ease-out");
    this.el.style.MozTransition = "height ".concat(this.duration, "ms ease-out");
    this.el.style.OTransition = "height ".concat(this.duration, "ms ease-out");
    this.el.style.transform = "height ".concat(this.duration, "ms ease-out");
    this.el.style.overflow = 'hidden';
    this.el.style.height = this.minHeight + 'px';
    // this.el.classList.add('js-active');

    this.update();
    attach(window, 'resize', function () {
      if (_this.el.classList.contains('js-active')) {
        _this.el.style.height = 'auto';
        clearTimeout(_this.reinit);
        _this.reinit = setTimeout(function () {
          _this.el.style.height = _this.el.clientHeight + 'px';
        }, 500);
      } else {
        _this.el.style.height = _this.minHeight + 'px';
      }
    }, 250);
  }
  _createClass(toggleHeight, [{
    key: "update",
    value: function update() {
      this.currentHeight = this.el.clientHeight;
    }
  }, {
    key: "animate",
    value: function animate() {
      var _this2 = this;
      var to = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'auto';
      this.update();
      if (to === 'auto') {
        this.el.classList.add('js-active');
        this.el.style.height = 'auto';
        this.newHeight = this.el.clientHeight;
        this.el.style.height = this.currentHeight + 'px';
        setTimeout(function () {
          _this2.el.style.height = _this2.newHeight + 'px';
        }, 50);
      } else {
        this.el.classList.remove('js-active');
        this.el.style.height = to + 'px';
      }
    }
  }]);
  return toggleHeight;
}();
export default toggleHeight;